import React, { useState } from 'react';
import { TestTube, Play, CheckCircle2, XCircle, Sparkles, Loader2 } from 'lucide-react';

export const AITestGenerator = ({ project }) => {
  const [generating, setGenerating] = useState(false);
  const [tests, setTests] = useState([]);

  const generateTests = () => {
    setGenerating(true);
    setTimeout(() => {
      setTests([
        { id: 1, scenario: 'OTC: Create Sales Order -> Delivery -> Invoice -> Payment', process: 'Order-to-Cash', tcodes: ['VA01', 'VL01N', 'VF01', 'F-28'], test_data_req: 'Customer, Material, Pricing', priority: 'critical' },
        { id: 2, scenario: 'P2P: Purchase Requisition -> PO -> Goods Receipt -> Invoice Verification', process: 'Purchase-to-Pay', tcodes: ['ME51N', 'ME21N', 'MIGO', 'MIRO'], test_data_req: 'Vendor, Material, Plant', priority: 'high' },
        { id: 3, scenario: 'R2R: Journal Entry -> Posting -> Period Close', process: 'Record-to-Report', tcodes: ['FB01', 'FB50', 'F.16'], test_data_req: 'GL Accounts, Cost Centers', priority: 'high' },
        { id: 4, scenario: 'Manufacturing: Production Order -> Confirmation -> Goods Receipt', process: 'Plan-to-Produce', tcodes: ['CO01', 'CO15', 'MB31'], test_data_req: 'BOM, Routing, Material', priority: 'medium' }
      ]);
      setGenerating(false);
    }, 2500);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">AI Test Scenario Generator</h2>
            <p className="text-gray-600">Generate 100+ end-to-end test scenarios across processes</p>
          </div>
          <button onClick={generateTests} disabled={generating} className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-xl hover:shadow-lg flex items-center space-x-2 disabled:opacity-50">
            {generating ? <><Loader2 className="w-5 h-5 animate-spin" /><span>Generating...</span></> : <><Sparkles className="w-5 h-5" /><span>AI Generate</span></>}
          </button>
        </div>
      </div>

      {tests.length === 0 && (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <TestTube className="w-20 h-20 mx-auto mb-6 text-gray-300" />
          <p className="text-gray-600 mb-6">Generate comprehensive test scenarios with AI</p>
          <button onClick={generateTests} className="bg-blue-600 text-white px-8 py-3 rounded-xl hover:bg-blue-700">Generate Tests</button>
        </div>
      )}

      {tests.length > 0 && (
        <div className="space-y-6">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
            <h3 className="text-2xl font-bold mb-2">{tests.length} Test Scenarios Generated</h3>
            <p className="text-blue-100">Covering all critical business processes</p>
          </div>

          <div className="space-y-3">
            {tests.map((test) => (
              <div key={test.id} className="bg-white rounded-xl border-2 border-gray-200 p-5">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <h4 className="font-semibold text-gray-900">{test.scenario}</h4>
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        test.priority === 'critical' ? 'bg-red-100 text-red-700' :
                        test.priority === 'high' ? 'bg-orange-100 text-orange-700' :
                        'bg-blue-100 text-blue-700'
                      }`}>{test.priority}</span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">{test.process}</p>
                    <div className="flex items-center space-x-4 text-xs text-gray-500">
                      <span>T-Codes: {test.tcodes.join(' → ')}</span>
                      <span>Test Data: {test.test_data_req}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AITestGenerator;